export default __webpack_public_path__ + "static/media/preference content1.8b1ad6b1.jpg";